window.onload = function () {
    // Target elements that contain text
    let elements = document.querySelectorAll("p, span, div, li, dd, td, small, dt, dl, ul");

    elements.forEach(function (element) {
        // Process only elements that contain text nodes (no children)
        if (!element.hasChildNodes()) return;

        element.childNodes.forEach(function (node) {
            if (node.nodeType === Node.TEXT_NODE) { // Process only text nodes
                let text = node.nodeValue.trim(); // Get raw text without formatting

                // Regex to match the Shopify printxpand URL (handling extra spaces & quotes)
                let urlPattern = /["']?\s*(https?:\/\/app\.dripappsserver\.com\/[^\s"']+)\s*["']?/g;

                // If the text contains a valid URL, replace it with an <a> tag
                if (text.match(urlPattern)) {
                    console.log("Found URL:", text.match(urlPattern));

                    // Replace raw text without modifying HTML structure
                    let replacedText = text.replace(urlPattern, function (match, url) {
                        return `<a href="${url}" target="_blank" rel="noopener noreferrer">Preview</a></br>`;
                    });

                    let newSpan = document.createElement("span");
                    newSpan.innerHTML = replacedText; // Inject HTML properly
                    element.replaceChild(newSpan, node);
                }
            }
        });
    });
};
